import React, {useEffect, useState} from 'react';
import Card from "../components/Card/Card";
import { FaRegSmile, FaRegFrown } from "react-icons/fa";
import IndicatorsCounts from "../components/IndicatortsCounts/IndicatorsCounts";
import {IndicatorsServices} from "../services/IndicatorsServices";

const HomePage = () => {
  const [filter, setFilter] = useState('all');
  const [indicators, setIndicatores] = useState();

  const handleFilterChange = (filterType) => {
    setFilter(filterType);
  };

  const filterCards = (type) => {
    if (filter === 'all') return true;
    return type === filter;
  };

  useEffect(() => {
    IndicatorsServices.getIndicatorsList().then((response) => {
      setIndicatores(response);
    });
  }, []);


  const renderIndicators = () => {
    return (
      <>
        <IndicatorsCounts numberTotal={indicators?.length} goodNumbers={indicators?.filter((indicator) => indicator["classification"] === "Adequado").length} badNumbers={indicators?.filter((indicator) => indicator["classification"] === "Atencao").length} />
        <h2 className="text-2xl text-center mt-2 text-emerald-700 font-bold py-2">Resultados da Pesquisa</h2>
        <div className="w-2/3 h-[1.5px] mb-8 bg-emerald-700"></div>
        <div className="flex mb-8">
          <button
              className={`text-lg border border-green-select sm:px-4 px-2 py-2 rounded-l ${filter === 'all' ? 'text-white bg-green-select hover:bg-[#364744]' : "text-green-select hover:bg-green-select hover:text-white"}`}
              onClick={() => handleFilterChange('all')}
          >
            Todos
          </button>
          <button
              className={`flex flex-row items-center border border-green-select border-l-0 border-r-0 text-lg sm:px-4 px-2 py-2 ${filter === 'Adequado' ? 'bg-emerald-700 text-white hover:bg-emerald-800' : "text-green-select hover:bg-emerald-700 hover:text-white"}`}
              onClick={() => handleFilterChange('Adequado')}
          >
            <FaRegSmile className={`text-xl mr-1 ${filter === 'Adequado' && 'text-white'}`} />
            Adequados
          </button>
          <button
              className={`flex flex-row items-center border border-green-select text-lg hover:bg-gray-600 sm:px-4 px-2 py-2 rounded-r ${filter === 'Atencao' ? 'bg-yellow-600 text-white hover:bg-yellow-700' : "text-green-select hover:bg-yellow-600 hover:text-white"}`}
              onClick={() => handleFilterChange('Atencao')}
          >
            <FaRegFrown className={`text-xl mr-1 ${filter === 'Atencao' && 'text-white'}`} />
            Atenção
          </button>
        </div>
        <div className="flex flex-wrap gap-12 md:px-[2.5%] h-full justify-center items-center">
          {indicators && indicators.map((indicator) => (
            <Card
              key={indicator.name}
              title={indicator.name}
              dimension={indicator.dimension}
              type={indicator.classification}
              longDescription={indicator.classification === "Adequado" ? indicator.longDescriptionForSatisfactoryResult : indicator.longDescriptionForAttentionResult}
              show={filterCards(indicator.classification)}
            />
          ))}
        </div>
      </>
    );

  }

  return (
    <div className="flex flex-col items-center justify-center pb-8 py-10">
      {indicators && indicators.length !== 0 ?
        renderIndicators()
        :
        <>
          <div className="flex justify-center items-center pt-64">
            <h2 className="text-2xl text-center mt-2 text-emerald-700 font-bold py-2">Resultados da pesquisa ainda não disponiveis</h2>
          </div>
        </>
      }
    </div>
  );
};

export default HomePage;
